import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../../../components/AppShell/styles";

const MOBILE = `not all and (min-width: ${DESKTOP_BREAKPOINT})`;

/* The steps, on top of the screen (where the person is in the flow), thin, with a line under them separating the
   screen's own header and content (same color as the app's lines) */
export const Wrapper = styled.div`
  position: relative;
  padding: 0.75rem 2rem;

  &::after {
    position: absolute;
    right: 2rem;
    bottom: 0;
    left: 2rem;
    height: 1px;
    content: "";
    background: var(--color-neutral-dark);
  }

  @media ${MOBILE} {
    padding: 10px 20px;

    &::after {
      right: 20px;
      left: 20px;
    }
  }
`;

/* Numbered steps joined by a line */
export const Steps = styled.ol`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;

  /* Each step keeps its whole name: the lines between them give way when the column is narrow */
  li {
    display: flex;
    flex: 1 0 auto;
    gap: 0.5rem;
    align-items: center;
    font-family: Inter, sans-serif;
    font-size: 0.75rem;
    font-weight: 700;
    color: var(--color-neutral-150);

    &:last-child {
      flex: 0 0 auto;
    }

    /* The line to the next step */
    &:not(:last-child)::after {
      flex: 1;
      min-width: 0.75rem;
      height: 2px;
      margin: 0 0.75rem;
      content: "";
      background: var(--color-neutral-base);
      border-radius: 2px;
    }

    &.done:not(:last-child)::after {
      background: var(--color-brand-blue);
    }
  }

  .dot {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    font-size: 0.6875rem;
    color: var(--color-neutral-150);
    border: 2px solid var(--color-neutral-base);
    border-radius: 100%;
  }

  .label {
    white-space: nowrap;
  }

  li.current {
    color: var(--color-neutral-white);
  }

  li.done .dot {
    color: var(--color-neutral-white);
    background: var(--color-brand-blue);
    border-color: var(--color-brand-blue);
  }

  /* Where the person is: a white dot, its number in the background color */
  li.current .dot {
    color: var(--color-neutral-darkness);
    background: var(--color-neutral-white);
    border-color: var(--color-neutral-white);
  }

  /* Phones: only the current step keeps its name */
  @media ${MOBILE} {
    li:not(.current) .label {
      display: none;
    }
  }
`;
